// src/services/postSignInBootstrap.js
import { db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

/**
 * Garante o perfil padrão do usuário:
 * - Preenche nome/sobrenome a partir do displayName do Google
 * - Define fotoPerfil a partir de photoURL do Google
 * - Define selooficial e selosGanhos iniciais
 * - NÃO sobrescreve o que já existe; apenas completa o que estiver faltando
 */
export async function ensureUserProfile(user) {
  if (!user) return;

  const uid = user.uid;
  const email = (user.email || "").toLowerCase();
  const displayName = (user.displayName || "").trim();
  const photoURL = (user.photoURL || "").trim();

  // nome e sobrenome a partir do displayName
  let nome = "";
  let sobrenome = "";
  if (displayName) {
    const p = displayName.split(" ");
    nome = p[0] || "";
    sobrenome = p.slice(1).join(" ") || "";
  }

  const userRef = doc(db, "usuarios", uid);
  const snap = await getDoc(userRef);
  const curr = snap.exists() ? (snap.data() || {}) : {};

  // Só preenche se estiver faltando
  const payload = {
    email: email || curr.email, // ok atualizar
    ultimaatualizacao: new Date().toLocaleString(),

    ...(curr.nome ? {} : { nome }),
    ...(curr.sobrenome ? {} : { sobrenome }),
    ...(curr.estado ? {} : { estado: curr.estado ?? "" }),
    ...(curr.fotoPerfil ? {} : { fotoPerfil: photoURL || "" }),
    ...(curr.fotoCabecalho ? {} : { fotoCabecalho: "" }),

    ...(curr.criadoEm ? {} : { criadoEm: new Date().toISOString() }),
    ...(typeof curr.pontuacao === "number" ? {} : { pontuacao: 0 }),
    ...(curr.selooficial ? {} : { selooficial: "estreia-oficial" }),
    ...(Array.isArray(curr.selosGanhos) && curr.selosGanhos.length
      ? {}
      : { selosGanhos: ["estreia-oficial"] }),
    ...(Array.isArray(curr.amigos) ? {} : { amigos: [] }),
    ...(curr.amizadesPendentes
      ? {}
      : { amizadesPendentes: { enviadas: [], recebidas: [] } }),
  };

  await setDoc(userRef, payload, { merge: true });

  // mapaEmailsParaUIDs (best-effort)
  try {
    if (email) {
      const emailID = email.replace(/\./g, ",");
      await setDoc(
        doc(db, "mapaEmailsParaUIDs", emailID),
        { uid, email, nome: displayName || `${nome} ${sobrenome}`.trim() },
        { merge: true }
      );
    }
  } catch (e) {
    console.warn("Aviso: mapaEmailsParaUIDs não atualizado:", e);
  }
}
